import { render, staticRenderFns } from "./weeklysale.vue?vue&type=template&id=61c85200&"
import script from "./weeklysale.vue?vue&type=script&lang=js&"
export * from "./weeklysale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports